import IndexLinks from "../IndexLinks"

const HelpTopicCompteIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte/1'},
  ]

  const links = [
    { title: 'Créer un compte', link: '/topics/compte/1'},
    { title: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { title: 'Sécurité du compte', link: '/topics/compte/securite'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicCompteIndex